<template>
  <!--    <el-header class="header">-->
  <!--      <header class="logo-warp">-->
  <!--        <img class="logo" src="@assets/menu-nav/logo.png" alt/>-->
  <!--        <div class="title">找回密码</div>-->
  <!--      </header>-->
  <!--    </el-header>-->
  <div class="main-container">
    <div class="container">
      <div class="left">
        <el-carousel indicator-position="outside" height="100%">
          <el-carousel-item v-for="item in 4" :key="item">
            <img src="img/login.png" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-form v-if="!verCode" ref="ruleForm" :model="ruleForm" :rules="rules" class="login-form">
        <p class="title">欢迎使用精诊三维</p>
        <p class="subTitle">激活账号</p>
        <el-form-item prop="mobile">
          <el-input
            class="login_input"
            placeholder="手机号"
            size="large"
            v-model="ruleForm.mobile"
          >
            <!--            <template slot="prepend">+86</template>-->
            <i slot="prefix" class="el-icon-mobile-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code" class="verCode">
          <el-input
            class="login_input"
            v-model="ruleForm.code"
            size="large"
            style="width: 50%"
            placeholder="输入验证码"
          >
            <i slot="prefix" class="el-icon-message"></i>
          </el-input>
          <div style="float: right">
            <img :src="vImg" alt="" @click="handleChangeImg" v-if="imgVisible">
            <el-button type="text" @click="handleChangeImg">换一张</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            class="login_btn"
            :loading="loading"
            size="large"
            type="primary"
            @click="submitForm('ruleForm')"
            block>
            下一步
          </el-button>
          <a class="login-form-forgot" @click="gotoLoginPage">返回登录页面</a>
        </el-form-item>
      </el-form>
      <el-form v-else ref="ruleForm" :model="resetForm" :rules="rules" class="login-form">
        <p class="title">正在激活账号</p>
        <p class="subTitle">请设置您的密码</p>
        <el-form-item prop="code" class="verCode">
          <el-input
            class="login_input"
            placeholder="短信验证码"
            size="large"
            style="width: 60%"
            v-model="resetForm.code"
          >
          </el-input>
          <el-button type="text" class="send-code" :class="{'disabled': (count !== 60 || !resetForm.verify)}"
                     @click="handleSend"
                     :disabled="(count !== 60 || !resetForm.verify)">{{ count !== 60 ? count + '秒后重新发送' : '重新发送' }}
          </el-button>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            class="login_input"
            v-model="resetForm.password"
            :type="resetForm.psd"
            size="large"
            placeholder="请设置您的密码"
          >
            <img slot="suffix" class="hideSwich" ref="view" @mouseover="imgop(1)" @mouseout="imgop1(1)" @click="imgswich(1)" src="@assets/hide1.png"/>
            <img slot="suffix" class="hideSwich" ref="hide" @mouseover="imgop(1)" @mouseout="imgop1(1)" style="display:none" @click="imgswich(2)" src="@assets/view1.png"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="repeatPassword">
          <el-input
            class="login_input"
            v-model="resetForm.repeatPassword"
            :type="resetForm.psd1"
            size="large"
            placeholder="请再次输入密码"
          >
            <img slot="suffix" class="hideSwich" ref="view1" @mouseover="imgop(2)" @mouseout="imgop1(2)" @click="imgswich(3)" src="@assets/hide1.png"/>
            <img slot="suffix" class="hideSwich" ref="hide1" @mouseover="imgop(2)" @mouseout="imgop1(2)" style="display:none" @click="imgswich(4)" src="@assets/view1.png"/>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            class="login_btn"
            :loading="loading"
            size="large"
            type="primary"
            @click="submitResetForm('ruleForm')"
            block
          >
            确认修改
          </el-button>
          <a class="login-form-forgot" @click="gotoLoginPage">返回登录页面</a>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {login} from '@/api';

const baseUrl = '/common/getVerifyCode';

export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (String(value).length !== 11) {
        callback(new Error('请输入正确的电话号码！'));
        return;
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,16}$/.test(value)) {
        callback(new Error('密码由6-16个字符组成，其中包含大写字母，小写字母，数字!'));
      } else {
        callback();
      }
    };
    const validateRePass = (rule, value, callback) => {
      if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      imgVisible: true,
      vImg: baseUrl,
      loading: false,
      ruleForm: {
        mobile: '',
        code: '',
      },

      count: 60,
      timer: null,
      verCode: false,
      resetForm: {
        verify: '',
        mobile: '',
        password: '',
        repeatPassword: '',
        code: '',
        psd: 'password',
        psd1: 'password',
      },
      rules: {
        mobile: [
          {required: true, message: '请输入电话', trigger: 'blur'},
          {validator: validateMobile, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请设置登录密码', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        repeatPassword: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
          {validator: validateRePass, trigger: 'blur'}
        ],
      }
    };
  },
  methods: {
    gotoLoginPage() {
      this.$router.push({
        name: 'Login'
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.$router.push({
          //   path: '/resetPass'
          // });

          this.resetForm.mobile = this.ruleForm.mobile;
          this.resetForm.verify = this.ruleForm.code;

          this.handleSend();
          window.localStorage.setItem('mobile', this.ruleForm.mobile);
          window.localStorage.setItem('verify', this.ruleForm.code);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleChangeImg() {
      this.imgVisible = false;
      this.vImg = `${baseUrl}?time=${new Date().valueOf()}`;
      this.$nextTick(() => {
        this.imgVisible = true;
      });
    },
    initData() {
      this.vImg = `${baseUrl}?time=${new Date().valueOf()}`;
    },

    handleSend() {
      if (!this.resetForm.verify) return;
      login.smsSend({
        mobile: this.resetForm.mobile,
        verify: this.resetForm.verify,
      })
        .then(res => {
          if (res.code === 10000) {
            this.count = this.count - 1;
            this.$message.success('短信验证码发送成功！');
            this.verCode = true;
            this.timer = setInterval(() => {
              if (this.count <= 0) {
                this.count = 60;
                clearInterval(this.timer);
              } else {
                this.count = this.count - 1;
              }
            }, 1000);
            return;
          }
          this.verCode = false;
          this.count = 60;
          this.$message.error(res.msg);
        });
    },
    imgswich(res) {
      if (res === 1) {
        this.resetForm.psd = '';
        this.$refs.view.style.display = 'none';
        this.$refs.hide.style.display = 'block';
      } else {
        if (res === 2) {
          this.resetForm.psd = 'password';
          this.$refs.hide.style.display = 'none';
          this.$refs.view.style.display = 'block';
        } else {
          if (res === 3) {
            this.resetForm.psd1 = '';
            this.$refs.view1.style.display = 'none';
            this.$refs.hide1.style.display = 'block';
          } else {
            this.resetForm.psd1 = 'password';
            this.$refs.hide1.style.display = 'none';
            this.$refs.view1.style.display = 'block';
          }
        }
      }
    },
    imgop(res) {
      if (res === 1) {
        this.$refs.hide.style.opacity = '1';
        this.$refs.view.style.opacity = '1';
      } else {
        this.$refs.hide1.style.opacity = '1';
        this.$refs.view1.style.opacity = '1';
      }
    },
    imgop1(res) {
      if (res === 1) {
        this.$refs.hide.style.opacity = '0.6';
        this.$refs.view.style.opacity = '0.6';
      } else {
        this.$refs.hide1.style.opacity = '0.6';
        this.$refs.view1.style.opacity = '0.6';
      }
    },
    submitResetForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          login.userResetPassword({
            repeatPassword: this.resetForm.repeatPassword,
            mobile: this.resetForm.mobile,
            sms: this.resetForm.code,
            password: this.resetForm.password
          })
            .then(res => {
              if (res.code === 10000) {
                this.$message.success('密码修改成功，3秒后跳转到登录！');
                let here = this;
                setTimeout(function() {
                  here.$router.push({
                    path: '/login'
                  });
                }, 3000);
                return;
              }
              this.$message.error(res.msg);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none;
  user-select: none;
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
  box-sizing: border-box;
}

.left {
  float: left;
  display: inline-block;
  background: url('~@/assets/login.png') no-repeat;
  width: 442px;
  height: 462px;
}

.left .el-carousel {
  height: 100%;
  overflow: hidden;
}

main {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.login-form {
  float: right;
  padding: 26px 52px;
  width: 442px;
  height: 462px;
  background: #fff;
}

.login-form-forgot {
  float: right;
  color: #999;
  text-decoration: none;
}

.login-form-icon {
  color: rgba(0, 0, 0, .36);
}

.login-form .title {
  margin: 0;
  font-size: 32px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #333333;
  line-height: 45px;
}

.login-form .subTitle {
  margin-bottom: 26px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #333333;
  line-height: 22px;
}

.el-input {
  width: 335px;
  height: 58px;
}

.el-input__inner {
  height: 58px;
  background: rgba(244, 248, 247, 1);
}

.el-input__prefix {
  line-height: 58px;
}

.login_btn {
  width: 335px;
  height: 56px;
  background: linear-gradient(45deg, #534BD5 0%, #5951FF 100%);
  box-shadow: 0px 20px 32px 0px rgba(12, 20, 73, 0.22);
  border-radius: 4px;
  margin-top: 20px;
}

.ant-btn-primary[disabled] {
  background: #d9d9d9;
}

.newUser {
  cursor: pointer;
  margin-top: 18px;
  font-size: 12px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #5850F8;
  line-height: 17px;
  text-align: center;
}

@media screen and (max-width: 576px) {
  .left {
    display: none;
  }

  .login-form {
    padding: 24px 16px;
    width: 94%;
    margin: 0 auto;
  }

  .el-input {
    width: 100%;
  }

  .login_btn {
    width: 100%;
  }
}

.verCode .el-form-item__content {
  display: flex;
  align-items: center;
}

#canvas {
  height: 58px;
}

.header {
  border-bottom: 1px solid #ededed;
}

.logo-warp {
  display: flex;
  height: 60px;
  align-items: center;
}

.logo {
  height: 60px;
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #9fa0a0;
}

.main-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /*opacity:0.5;*/
  background: url('~@/assets/login-background.jpg') no-repeat;
  background-size: 100%;
}

.container {
  box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.1);
}

.ruleForm {
  width: 400px;
}

.send-code {
  margin-top: 10px;
  margin-right: 10%;
  float: right;
  /*background: rgba(71, 78, 96, 1);*/
  border-radius: 4px;
  /*color: #D4D6DA;*/
  border: 1px solid rgba(255, 255, 255, 1);
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/view/FindPass/index.vue